import { Apple, Tag, Wheat } from 'lucide-react';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

import { IngredientWithDetails } from '../types/ingredient-types';
import { IngredientAllergenTab } from './ingredient-allergen-tab';
import { IngredientNutritionTab } from './ingredient-nutrition-tab';

interface IngredientEditTabsProps {
  ingredient: IngredientWithDetails;
  isEditable: boolean;
}

export function IngredientEditTabs({
  ingredient,
  isEditable,
}: IngredientEditTabsProps) {
  return (
    <div className="border-l pl-6 flex h-full">
      <Tabs defaultValue="allergens" className="w-full flex flex-col">
        <div className="pr-6">
          <TabsList className="w-full border-b justify-start">
            <TabsTrigger value="allergens">
              <Wheat className="mr-2" /> Allergens
            </TabsTrigger>
            <TabsTrigger value="nutrition">
              <Apple className="mr-2" /> Nutrition
            </TabsTrigger>
            <TabsTrigger value="labels">
              <Tag className="mr-2" />
              Labels
            </TabsTrigger>
          </TabsList>
        </div>
        {/* // TODO: Tabscontent should just include these className values in component*/}
        <TabsContent value="nutrition" className="overflow-y-auto pr-6 pb-6">
          <IngredientNutritionTab
            ingredient={ingredient}
            isEditable={isEditable}
          />
        </TabsContent>
        <TabsContent value="allergens" className="overflow-y-auto pr-6 pb-6">
          <IngredientAllergenTab
            ingredient={ingredient}
            isEditable={isEditable}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
}
